<script lang="ts">
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { cx } from '@emotion/css';
  import { ResponsiveVars } from '@twist/core';

  const responsiveVars = new ResponsiveVars().addFluid('size', toFluidVarInput(18, 24)).toCSS();
</script>

<div class={cx(responsiveVars, 'accessibility-checkbox')}>
  <slot />
</div>

<style lang="scss">
  @import 'src/scss/media';

  .accessibility-checkbox {
    width: var(--size);
    height: var(--size);
  }
</style>
